function SectionTitle({ title }) {
  return (
    <div className="text-center my-5">
      <h3 className="fw-bold">{title}</h3>

      {/* Decorative Line */}
      <div
        style={{
          width: "120px",
          height: "4px",
          backgroundColor: "#f39c12",
          margin: "10px auto",
          borderRadius: "5px"
        }}
      ></div>
    </div>
  );
}

export default SectionTitle;
